/* import __COLOCATED_TEMPLATE__ from './lsg-custom-dropdown.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import clsx from 'clsx';


const MENU_ITEM_TYPES = {
  DEFAULT: '',
  SEPARATOR: 'separator',
};

export const LSG_CUSTOM_DROPDOWN = {
  MENU_ITEM_TYPES,
};

const CLASS_NAME = 'LSG-c-custom-dropdown';
const TRIGGER_BUTTON_CLASS_NAME = `${CLASS_NAME}__menu-button`;

class LsgCustomDropdown extends Component {
  @service router;

  get CLASS_NAME() {
    return CLASS_NAME;
  }

  get containerClass() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get triggerClasses() {
    return clsx(
      'dropdown-trigger',
      TRIGGER_BUTTON_CLASS_NAME,
    );
  }

  get renderPlacement() {
    return this.args.renderInPlace ?? true;
  }

  get alignment() {
    return this.args.alignment ?? 'right';
  }

  get menuItems() {
    return this.args.menuItems?.map((item) => {
      const props = { ...item };

      props.class = (props.type === LSG_CUSTOM_DROPDOWN.MENU_ITEM_TYPES.SEPARATOR || props.hasSeparatorAfter)
        ? 'has-separator-after'
        : null;

      if (props.link) {
        if (props.link.model && props.link.query) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.model,
            props.link.query
          );
        } else if (props.link.query) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.query
          );
        } else if (props.link.model) {
          props.url = this.router.urlFor(
            props.link.route,
            props.link.model
          );
        } else {
          props.url = this.router.urlFor(props.link.route);
        }
      }

      return props;
    });
  }

  @action
  onButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  @action
  onLinkClick(dropdown, menuItem, e) {
    e.preventDefault();
    e.stopPropagation();

    dropdown.actions.close();

    if (menuItem.link.model && menuItem.link.query) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.model,
        menuItem.link.query
      );
    } else if (menuItem.link.query) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.query
      );
    } else if (menuItem.link.model) {
      return this.router.transitionTo(
        menuItem.link.route,
        menuItem.link.model
      );
    }

    return this.router.transitionTo(menuItem.link.route);
  }

  @action
  onMenuClick(dropdown, fn, e) {
    e.preventDefault();
    e.stopPropagation();
    dropdown.actions.close();
    fn();
  }
}

export default LsgCustomDropdown;
